import React from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import styles from './Header.module.css'

export default function Header({ companyName, textReplyTime, handleOpen }) {
  return (
    <div className={styles.root}>
      <span className={styles.close_btn} onClick={handleOpen}>
        <AiOutlineClose />
      </span>
      <div className={styles.logo}>
      </div>
      <div className={styles.texts}>
        <span className={styles.texts_h1}>{companyName}</span>
        <span className={styles.texts_span}>{textReplyTime}</span>
      </div>
    </div>
  )
}
